import { useCallback, useEffect, useState } from "react";
import { useAuthStore } from "@/features/auth/store/auth.store";
import { addRecentSearch, readRecentSearches } from "../utils/recent-searches";

/**
 * The signed-in user's recent Inspire searches. Nothing is kept for a visitor
 * with no user id, and one user's history is never shown to another.
 */
export function useRecentSearches(): {
	searches: readonly string[];
	record: (query: string) => void;
} {
	const userId = useAuthStore((state) => state.user?.id);
	const [searches, setSearches] = useState<string[]>([]);

	useEffect(() => {
		setSearches(userId ? readRecentSearches(userId) : []);
	}, [userId]);

	const record = useCallback(
		(query: string) => {
			if (!userId) return;
			setSearches(addRecentSearch(userId, query));
		},
		[userId],
	);

	return { searches, record };
}
